import React, { useCallback, useEffect, useRef, useState } from "react"
import { Card } from "flowbite-react"
import { ReactComponent as ArrowIcon } from "../../images/arrow-small.svg"
import { articleBreakPoints } from "../../utils/slider-utils"
import * as API from "../../services"
import { BLOGS_URL, CATEGORIES_URL } from "../../services/api"
import Loader from "../../components/Loader"
import Slider from "react-slick"
import { decodeHtmlEntities } from "../../utils"
import ArrowButtons from "../../components/ArrowButtons"

const CommonInsights = ({ data }) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [slideToShow, setSlideToShow] = useState(0)
  const [blogsData, setBlogsData] = useState([])
  const [loading, setLoading] = useState(true)
  const [categories, setCategories] = useState([])

  const fetchData = useCallback(async () => {
    setLoading(true)
    const blogURL = data.categoryId
      ? `${BLOGS_URL}&categories=${data.categoryId}`
      : BLOGS_URL
    let result = await API.GET(blogURL)
    let categoriesResult = await API.GET(CATEGORIES_URL)
    setBlogsData(result)
    setLoading(false)
    setCategories(categoriesResult)
  }, [data])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  const blogsSliderRef = useRef(null)

  const settings = {
    dots: false,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 2,
    initialSlide: 0,
    responsive: articleBreakPoints,
    cssEase: "linear",
    arrows: false,
    centerMode: false,
    afterChange: current => {
      const { slidesToShow } = blogsSliderRef.current.innerSlider.track.props
      setSlideToShow(slidesToShow)
      setCurrentIndex(current)
    },
  }

  const nextSlide = () => {
    blogsSliderRef.current.slickNext()
  }

  const prevSlide = () => {
    blogsSliderRef.current.slickPrev()
  }
  return (
    <section
      id="insights"
      className=" grid  items-center gap-[3rem] md:gap-[5.5rem]  grid-cols-1  py-16 md:py-[6.75rem] "
    >
      <div
        className={`flex justify-end z-[2] px-6 md:px-20  flex-col-reverse md:flex-col  gap-6 items-start `}
      >
        <div className="flex flex-col gap-6 w-full">
          <h2
            className={`text-gray-100 text-[3.7rem] md:text-7xl  lg:text-8xl tracking-[-3.36px] lg:tracking-tight-7% `}
          >
            {data.label}
          </h2>
          <div className="flex w-full justify-between items-center gap-4">
            <ArrowButtons
              theme={"dark"}
              nextDisabled={currentIndex >= blogsData.length - slideToShow}
              prevDisabled={currentIndex === 0}
              nextClick={nextSlide}
              prevClick={prevSlide}
            />
          </div>
        </div>
      </div>
      <Slider
        className={`usecase-slider animate-fade transition delay-500 `}
        ref={blogsSliderRef}
        {...settings}
      >
        {loading ? (
          <div className="w-full justify-center items-center">
            <Loader />
          </div>
        ) : blogsData.length ? (
          blogsData.map((item, index) => {
            const postCategories = item.categories.map(
              categoryId =>
                categories.find(category => category.id === categoryId)?.name ||
                `Category ${categoryId}`,
            )
            return (
              <div key={index} className="px-4 py-1">
                <Card
                  className=" rounded-[2rem] shadow-none border-gray-300"
                  imgAlt="image 1"
                  imgSrc={item.yoast_head_json?.og_image?.[0]?.url || null}
                  theme={{
                    root: {
                      children:
                        "flex h-full flex-col justify-center gap-2 px-4 py-6",

                      href: "hover:bg-gray-100 dark:hover:bg-gray-700",
                    },
                  }}
                >
                  <h5 className="text-lg  min-h-[50px] font-normal md:text-[1.25rem]   tracking-tight text-secondary-100">
                    {decodeHtmlEntities(item.title.rendered)}
                  </h5>
                  <h6 className="text- text-gray-200 ">
                    {postCategories.join(", ")}
                  </h6>
                  <p className="text-base text-gray-100 tracking-tight">
                    {decodeHtmlEntities(item.yoast_head_json?.description) ||
                      decodeHtmlEntities(item.excerpt.rendered)}
                  </p>
                  <a
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex mt-2 justify-end items-center gap-4 text-lg text-blue-100"
                  >
                    <span>Read More</span>
                    <ArrowIcon className="scale-150" />
                  </a>
                </Card>
              </div>
            )
          })
        ) : (
          <div className="px-6">No Data found</div>
        )}
      </Slider>
    </section>
  )
}

export default CommonInsights
